/* eslint-disable */
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.timeout = 5000

export default new Vuex.Store({
  state: {
    CODE: '',
    STATE_CODE: '',
    VOD_ADDRESS: '',
    VOD_ADDRESS_EN: '',
    VOD_COVER: '',
    VOD_NANE: '',
    CURRENT_AREA: '1',
    ORDER_START_TIME: '',
    ORDER_END_TIME: '',
    detailShow: false,
    noticeShow: false,
    loading: false,
    isArea: false,
    TIP_SHOW: false,
    IS_AREA: false,
    IS_BIND: false, // 是否已绑定饭卡
    IS_COMMIT: false,
    USER_DATA: {}, // 用户数据
    BASE_DATA: {
      DESCRIPTION: '最低消费--',
      BULLETIN: '无法获取公告信息...', // 公告缩略
      MIN_PRICE: '0', // 最低配送金额
      NOTICE: '公告数据获取失败...' // 系统公告
    }, // 基础数据
    selectFoods: [],
    TABS_ACTIVE: 0
  },
  actions: {
    getData ({ state }, params) {
      return new Promise((resolve, reject) => {
        axios.post('/ci/zwb', Qs.stringify(params), { timeout: 8000 })
          .then(response => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  },
  getters: {
    getDetails: (state) => (params) => {
      return state.USER_DATA[params] ? state.USER_DATA[params] : '...'
    }
  },
  mutations: {
    detailShow (state) {
      state.detailShow = !state.detailShow
    },
    noticeShow (state) {
      state.noticeShow = !state.noticeShow
    },
    loading (state) {
      state.loading = !state.loading
    },
    changeArea (state, index) {
      state.CURRENT_AREA = index
    },
    coverState (state, value) {
      state.IS_AREA = value
    },
    changeTabs (state, value) {
      state.TABS_ACTIVE = value
    },
    tipShow (state, value) {
      state.TIP_SHOW = value
    },
    changeOffice (state, value) {
      if (state.CURRENT_AREA === '1') {
        if (state.USER_DATA.fAddress) {
          state.USER_DATA.fAddress = value
        }
      } else if (state.CURRENT_AREA === '2') {
        if (state.USER_DATA.fAddress_xh) {
          state.USER_DATA.fAddress_xh = value
        }
      }
    },
    upDateMoney (state, value) {
      if (state.USER_DATA.fBalance && state.USER_DATA.fSubsidy) {
        state.USER_DATA.fBalance = value.balance
        state.USER_DATA.fSubsidy = value.subsidy
      }
    },
    changeBind (state) {
      state.IS_BIND = true
    },
    upDateSelectFoods (state, values) {
      state.selectFoods = values
    },
    upDateBaseData (state, value) {
      state.USER_DATA = value
    },
    // 更新订餐截至时间
    upDateEndTime (state, value) {
      state.ORDER_END_TIME = value
    },
    changeCommit (state) {
      state.IS_COMMIT = !state.IS_COMMIT
    }
  }
})
